/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Card } from './Card';
import { lighten } from '@theme-ui/color';
export var FormErrorSummary = function (_a) {
    var className = _a.className, errors = _a.errors;
    return errors.length ? (jsx(Card, { sx: {
            borderColor: 'danger',
            bg: lighten('danger', 0.55),
            p: 2,
            color: 'danger',
        }, className: className },
        jsx("div", { sx: { fontSize: 3, mb: 2 } }, "Correct these errors before continuing"),
        jsx("ul", null, errors.map(function (error, i) { return (jsx("li", { key: i }, error)); })))) : null;
};
export function summariseError(name, error) {
    return error && typeof error === 'string' ? "".concat(name, ": ").concat(error) : '';
}
//# sourceMappingURL=FormErrorSummary.js.map